import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TaskService } from '../../../../services';
import {
  JobScreenDriverPerformanceTask,
  JobScreenDriverPerformanceTaskTracking,
} from '../../../../interfaces/screen-specific/job-screen';

@Component({
  selector: 'job-screen-driver-performance',
  templateUrl: './job-screen-driver-performance.component.html',
  styleUrls: ['./job-screen-driver-performance.component.scss'],
})
export class JobScreenDriverPerformanceComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() taskId!: number;
  @Input() organisationId!: number;
  @Input() organisationTypeId!: number;

  driverLineOptions: any;
  driverLineData: any;

  constructor(private taskService: TaskService) {}

  ngOnInit(): void {}

  ngAfterViewInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.taskId) {
      this.fetchTask(this.taskId);
    }
  }

  private fetchTask(taskId: number) {
    this.taskService
      .getForComponent(taskId, 'job-screen-driver-performance')
      .then((task: JobScreenDriverPerformanceTask) => {
        this.initMapData(task);
      });
  }

  private initMapData(task: JobScreenDriverPerformanceTask) {
    //Chart
    let chartLabel = [];
    let arrvar: any;
    let distYaxis = 1;
    let hours: string | number;
    let minutes: string | number;
    let diff = 0;
    let dist = 0;
    let speedData = [];
    let distData = [];

    let mtrps = 2.237;
    const mtrph = 0.000621371192;

    if (task.taskTracking && task.taskTracking.length > 0 && this.organisationTypeId != 2) {
      const digits = 2;
      const round = (x: any) =>
        x.toLocaleString(undefined, {
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
        });
      const batround = (x: any) =>
        x.toLocaleString(undefined, {
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
        });

      task.taskTracking.forEach((va: JobScreenDriverPerformanceTaskTracking) => {
        if (va.isHeading == false) {
          arrvar = new Date(va.timestamp);
          hours = arrvar.getHours();
          minutes = arrvar.getMinutes();
          if (hours < 10) {
            hours = '0' + hours;
          }
          if (minutes < 10) {
            minutes = '0' + minutes;
          }
          arrvar = hours + ':' + minutes;
          chartLabel.push(arrvar);

          arrvar = va.speed * mtrps;
          if (arrvar < 0) {
            arrvar = 0;
          }
          speedData.push(round(arrvar));

          if (dist == 0) {
            dist = va.odometer;
            arrvar = diff;
          } else {
            //diff1 = va.odometer - dist
            //if (diff1 >= 0) {
            //	diff = diff + diff1;
            //}
            diff = diff + (va.odometer - dist);
            arrvar = diff * mtrph;
            dist = va.odometer;
          }
          if (arrvar <= 10) {
            distYaxis = 1;
          } else if (arrvar > 10 && arrvar <= 100) {
            distYaxis = 10;
          } else if (arrvar > 100 && arrvar <= 150) {
            distYaxis = 15;
          } else if (arrvar > 150 && arrvar <= 200) {
            distYaxis = 20;
          } else if (arrvar > 200 && arrvar <= 250) {
            distYaxis = 25;
          } else if (arrvar >= 300) {
            distYaxis = 30;
          }
          distData.push(round(arrvar));
        }
      });

      this.driverLineOptions = {
        scaleShowValues: true,
        responsive: false,
        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        scales: {
          yAxes: [
            {
              id: 'Speed',
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
                stepSize: 10,
                fontColor: '#0083c9',
              },
              gridLines: {
                color: 'rgba(0, 131, 201, 0.1)',
              },
              scaleLabel: {
                display: true,
                labelString: 'Speed (MPH)',
                fontColor: '#0083c9',
                fontFamily: 'Arial',
                fontStyle: 'normal',
                fontSize: 16,
                padding: 6,
                lineHeight: 2,
              },
            },
            {
              id: 'Distance',
              type: 'linear',
              position: 'right',
              ticks: {
                autoSkip: true,
                beginAtZero: true,
                stepSize: distYaxis,
                fontColor: '#cc0055',
              },
              gridLines: {
                color: 'rgba(204, 0, 85, 0.1)',
              },
              scaleLabel: {
                display: true,
                labelString: 'Distance (Miles)',
                fontColor: '#cc0055',
                fontFamily: 'Arial',
                fontStyle: 'normal',
                fontSize: 16,
                padding: 6,
                lineHeight: 2,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                autoSkip: true,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      };

      this.driverLineData = {
        labels: chartLabel,
        datasets: [
          {
            label: 'Speed (MPH)',
            //backgroundColor: '#cc4e0e',
            borderColor: '#0083c9',
            yAxisID: 'Speed',
            //lineTension: 0,
            fill: false,
            data: speedData,
          },
          {
            label: 'Distance (Miles)',
            //backgroundColor: '#565656',
            borderColor: '#cc0055',
            yAxisID: 'Distance',
            //lineTension: 0,
            fill: false,
            data: distData,
          },
        ],
      };
    }
  }
}
